<app-ui-card>
  <div class="block-title">
    <div class="available-traffic-panel__header">
      <div class="available-traffic__title-wrap">
        <div class="available-traffic__icon">
          <i class="pi pi-box"></i>
        </div>

        <div class="available-traffic__title">Пакеты доступные для подключения</div>
        <p-badge
          *ngIf="trafficPacks?.length > 0"
          [value]="trafficPacks.length"
          severity="danger"
        ></p-badge>
      </div>
    </div>
  </div>

  <ng-container *ngIf="trafficPacks?.length > 0; else emptyTemplate">
    <p-carousel
      [value]="trafficPacks"
      [numVisible]="3"
      [numScroll]="1"
      [circular]="trafficPacks.length > 3"
      [showIndicators]="trafficPacks.length > 1"
      [showNavigators]="trafficPacks.length > 1"
      [responsiveOptions]="responsiveOptions"
      styleClass="traffic-packs-carousel"
    >
      <ng-template let-pack pTemplate="item">
        <div class="carousel-item">
          <div
            class="pack-card"
            [class.pack-card_disabled]="disabled"
          >
            <div class="pack-card__title">
              {{ pack.name }}
            </div>

            <div class="pack-card__actions">
              <button
                type="button"
                class="pack-card__buy-button"
                [disabled]="disabled || !!pack.loading"
                (click)="buyTrafficPack(pack)"
              >
                <svg-icon
                  *ngIf="!pack.loading"
                  name="cart"
                  class="pack-card__buy-icon"
                ></svg-icon>

                <svg-icon
                  *ngIf="!!pack.loading"
                  name="spinner"
                  class="pack-card__buy-icon icon-spinner"
                ></svg-icon>

                <span>
                  {{ pack.loading ? 'Загрузка...' : 'Купить' }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </ng-container>
</app-ui-card>


<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '385px' }" [draggable]="false" [closeOnEscape]="false">
  <ng-template pTemplate="header">
    <div class="p-dialog-custom-header">
      <p class="p-dialog-custom-header__title">
        Подтвердите покупку
      </p>
      <p class="p-dialog-custom-header__subtitle">
        {{ currentTrafficPack?.name }}
      </p>
    </div>
  </ng-template>
  <app-assist-payment-form
    *ngIf="visible"
    [trafficPack]="currentTrafficPack"
    [pnoId]="pnoId"
  ></app-assist-payment-form>
</p-dialog>

<ng-template #emptyTemplate>
  <div class="not-found-title">Доступные пакеты не найдены</div>
</ng-template>
